(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mx-pdp]').forEach(pdp => {
      if (pdp.dataset.initialized) return;
      pdp.dataset.initialized = 'true';
      const slides = [...pdp.querySelectorAll('[data-mx-slide]')];
      const thumbs = [...pdp.querySelectorAll('[data-mx-thumb]')];
      const counter = pdp.querySelector('[data-mx-counter]');
      const modelInstances = new Map();
      const models = [...pdp.querySelectorAll('model-viewer')];
      const loadModels = () => {
        if (!models.length || !window.Shopify?.loadFeatures) return;
        window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad: errors => {
          if (errors || !window.Shopify.ModelViewerUI) return;
          models.forEach(model => {
            if (!modelInstances.has(model)) modelInstances.set(model, new window.Shopify.ModelViewerUI(model));
          });
        }}]);
      };
      loadModels();
      const select = index => {
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.hidden = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
          if (i !== index) {
            slide.querySelectorAll('model-viewer').forEach(model => modelInstances.get(model)?.pause());
            slide.querySelectorAll('iframe').forEach(frame => {
              const url = new URL(frame.src);
              if (url.hostname.endsWith('youtube.com') || url.hostname.endsWith('youtube-nocookie.com')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), url.origin);
              if (url.hostname === 'player.vimeo.com') frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), url.origin);
            });
          }
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-pressed', String(i === index));
        });
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => select(index));
        thumb.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
          select(next);
          thumbs[next].focus();
        });
      });
      pdp.querySelector('[data-ma-view-model]')?.addEventListener('click', () => {
        const index = slides.findIndex(slide => slide.dataset.mediaType === 'model');
        if (index >= 0) { select(index); thumbs[index]?.focus(); }
      });
      const dialog = pdp.querySelector('[data-ma-image-dialog]');
      const fullImage = pdp.querySelector('[data-ma-full-image]');
      let opener;
      pdp.querySelectorAll('.mx-pdp__zoom').forEach(link => link.addEventListener('click', event => {
        if (!dialog?.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        fullImage.src = link.href;
        fullImage.alt = link.querySelector('img')?.alt || 'Specimen photograph';
        pdp.querySelector('[data-ma-original-image]').href = link.href;
        dialog.showModal();
      }));
      pdp.querySelector('[data-ma-image-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog?.addEventListener('close', () => opener?.focus());
      pdp.querySelector('[data-mx-variant]')?.addEventListener('change', event => {
        window.location.assign(event.target.selectedOptions[0].dataset.url);
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
